/* eslint-disable jira/filename-case */
import React from 'react';
import { HorizontalNavSkeleton } from '@jira/navigation-apps__horizontal-nav-common/src/ui/horizontal-nav-skeleton/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import type HorizontalNavJira from './ui/HorizontalNavJira.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const LazyHorizontalNavJira = lazyForPaint<typeof HorizontalNavJira>(
	() =>
		import(/* webpackChunkName: "async-horizontal-nav-jira" */ './ui/HorizontalNavJira.tsx').then(
			(HorizontalNavJira) => HorizontalNavJira,
		),
	{ ssr: false },
);

const AsyncHorizontalNav = () => (
	<Placeholder name="horizontal-nav-jira" fallback={<HorizontalNavSkeleton />}>
		<LazyHorizontalNavJira />
	</Placeholder>
);

export const AsyncHorizontalNavJira: React.FC<React.RefAttributes<unknown>> = AsyncHorizontalNav;
